const formatView = (num) => {
    if (num === undefined || num === null) {
        return 'N/A'; // Or any default value you prefer
    }

    if (typeof num !== 'number') {
        return 'Invalid'; // Handle cases where num is not a number
    }

    if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M'; // Format as millions
    } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k'; // Format as thousands
    } else {
        return num.toString(); // Return as is if less than 1000
    }   
};

module.exports = { formatView };

